var _defs, _g, _path, _path2, _path3, _path4, _g2, _path5, _g3, _path6, _path7, _path8, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeatquestSeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 777.751,
    height: 870.949,
    viewBox: "0 0 205.78 230.439",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(82.944 -82.944) rotate(87.668 7.593 1.06)",
    spreadMethod: "pad",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60d95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -95.68307 -95.68307 0 578.344 541.731)",
    spreadMethod: "pad",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60d95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(96.89233) rotate(-90 5.093 .508)",
    spreadMethod: "pad",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60d95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-2.25 -93.75 -93.75 2.25 315.864 542.018)",
    spreadMethod: "pad",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#30077f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b60d95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(74.1 -74.1) rotate(87 8.596 1.302)",
    spreadMethod: "pad",
    id: "g"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f1a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.053,
    stopColor: "#2f1a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#31dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -64.60892 -64.60892 0 311.266 547.606)",
    spreadMethod: "pad",
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f1a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#31dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -64.60892 -64.60892 0 444.47 547.606)",
    spreadMethod: "pad",
    id: "j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f1a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#31dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -64.60892 -64.60892 0 578.206 547.606)",
    spreadMethod: "pad",
    id: "k"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f1a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#31dcf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1000h1000V0H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.679 179.919l-206.566 119.44c-13.78 7.967-22.261 22.658-22.261 38.552v54.258h-19.724l-18.784 25.125 9.782 130.247c.734 9.766 8.885 17.315 18.697 17.315h10.123v15.766a42.879 42.879 0 0021.446 37.125l125.728 72.64s2.693-30.656 13.462-47.906c12.314-19.724 29.554-26.375 29.554-26.375s-3.382-5.25-4.884-17.125c0 0-16.906 1.875-16.655-34.125h6.637l1.702 16.839c.669 6.62 6.253 11.66 12.92 11.66h1.783v9.626c0 7.042 5.719 12.75 12.772 12.75h7.264c-8.892 2.25-30.807 8-41.325 23-10.52 15-15.528 34.75-19.035 70.25-3.506 35.5-2.504 39.875 7.639 49.375 10.144 9.5 22.666 6 22.666 6l12.648 11v20.25l17.407 6.5c3.632 12.125 20.036 24.5 41.325 24.5s37.694-12.375 41.325-24.5l17.408-6.5v-20.25l12.647-11s12.523 3.5 22.666-6c10.144-9.5 11.146-13.875 7.64-49.375-3.507-35.5-8.516-55.25-19.035-70.25-10.52-15-32.434-20.75-41.326-23h7.264c7.054 0 12.773-5.708 12.773-12.75v-9.625h1.783c6.667 0 12.25-5.04 12.92-11.661l1.702-16.84h6.637c.25 36-16.656 34.126-16.656 34.126-1.502 11.875-4.883 17.125-4.883 17.125s17.24 6.65 29.553 26.375c10.77 17.25 13.462 47.907 13.462 47.907l125.729-72.641c13.273-7.67 21.446-21.816 21.446-37.125v-15.766h10.123c9.812 0 17.963-7.55 18.696-17.315l9.783-130.247-18.785-25.125h-19.723V337.91c0-15.894-8.483-30.585-22.261-38.552l-206.566-119.44a48.59 48.59 0 00-48.643 0",
    fill: "#280008"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M633.969 542.481l.688-23.75h40.874l3.75-73.125h29.25l6.25 8.251-7.791 17.876-2.771 46.998h40.688l6.249 8.251-6.972 1.919-.965 13.58h-48.748c-5.097 1.368-8.467 2.25-8.69 2.25-1 0-45.562 6.001-45.562 6.001z",
    fill: "url(#b)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M555.422 541.981L511.94 455.49l-5.159-1.633v-8.626l31.243-.125 8.15 17.063h57.979l9.187-17.063h31.879l4.687 8.751h-9.555l-49.035 88.124zm18.008-22.749l19.417-36.063h-36.642z",
    fill: "url(#c)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M397.768 541.856l-2.505-84.187-4.482-3.812 4.112-8.626h102.763v23.625h-74.198v15.281h68.45v19.687h-68.45V519.2h72.581v22.656z",
    fill: "url(#d)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.182 542.794l-5.589-76.177-1.499 3.177-8.438-15.937 8.438-7.688h85.919c31.227 0 34.632 10.077 36.134 25.25 1.528 15.437-6.006 23.063-17.067 24.75 0 0 15.521-.5 15.521 22.874 0 21.751-16.866 23.751-32.998 23.751zm26.369-22.657h50.719c4.35 0 7.791-3.763 7.501-8.202-.266-4.037-3.544-7.173-7.501-7.173h-51.636zm-2.016-35.062h53.789c4.324 0 7.745-3.743 7.455-8.155-.265-4.011-3.524-7.126-7.455-7.126h-54.797z",
    fill: "url(#e)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.45 484.607a7.64 7.64 0 00-7.624-7.126h-56.045l1.031 15.281h55.014c4.423 0 7.921-3.743 7.623-8.155m-60.574 43.218h51.873c4.448 0 7.968-3.764 7.671-8.202a7.689 7.689 0 00-7.67-7.173h-52.812zm73.156-23.969s15.875-.5 15.875 22.875c0 21.75-17.25 23.75-33.75 23.75h-82.25l-7.25-96.625h87.875c31.938 0 35.42 10.077 36.955 25.25 1.564 15.438-6.142 23.063-17.455 24.75M420.594 477.481v15.281h71.438v19.688h-71.438v15.375h75.75v22.656H393.782l-3-96.625h107.25v23.625zM558.459 491.919l17.697 36.063 19.948-36.063zm58.697-38.063h32.75l-55.375 96.876h-36.875l-50.875-96.876h33l8.373 17.063h59.565zM685.531 453.856h29.25l-4.313 73.125h40.688l-1.687 23.75H640.22l.687-23.75h40.875z",
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M644.336 546.731l.456-15.75h40.789l3.75-73.125h21.207l-4.313 73.125h40.637l-1.119 15.75z",
    fill: "url(#g)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.656 336.731a5.997 5.997 0 003.02 5.207l.168.097v50.134h-12v-53.28a14.858 14.858 0 017.31-12.76l1.502-.883zM713.156 392.169v-50.17l.105-.06a6 6 0 003.02-5.208V325.21l1.564.919a14.854 14.854 0 017.311 12.76v53.28z",
    fill: "#ff6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.656 335.7a6.762 6.762 0 00-.812 3.189v53.28h-4v-53.28c0-3.598 1.837-6.962 4.812-8.955zM717.156 392.169v-53.28a6.772 6.772 0 00-.875-3.316v-5.681c3.012 1.987 4.875 5.375 4.875 8.998v53.279z",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.022 638.016l-.016.022c-1.508 2.207-3.075 4.5-4.683 6.858l-88.2-52.066c-4.49-2.652-7.28-7.536-7.28-12.744V564.98h12v15.105c0 .983.531 1.908 1.382 2.41l88.883 52.47-2.087 3.05M717.874 592.83l-88.196 52.066a8884.989 8884.989 0 00-4.684-6.858l-.016-.022c-.709-1.038-1.403-2.05-2.086-3.048l88.881-52.47a2.818 2.818 0 001.383-2.412V564.98h12v15.105c0 5.209-2.79 10.093-7.282 12.745M460.906 625.606c-5.719 6-8.156 11.25-8.156 11.25-14.25 4.22-27.094 13.25-32.219 42.25s-5.875 55.25-5.375 62 8.875 8.25 12.875 3 8.25-11.5 8.25-11.5v15.375c-6.375 10.5-17.268 10.27-24.5 5-8.063-5.875-6.5-14.25-5-43.625s9.375-54.375 16.25-63.25c8.225-10.618 22.25-18.75 37.875-20.5",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.894 643.868c-10.305 21.16-12.617 44.547-14.613 65.176-2.25 23.25-2.25 31.687.75 38.062 2.231 4.742 8.718 8.542 17.296 8.177-5.56 2.425-11.83 1.134-16.546-2.302-8.063-5.875-6.5-14.25-5-43.625s9.375-54.375 16.25-63.25a46.284 46.284 0 011.863-2.238",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.094 625.606c5.719 6 8.156 11.25 8.156 11.25 14.25 4.22 27.094 13.25 32.219 42.25s5.875 55.25 5.375 62-8.875 8.25-12.875 3-8.25-11.5-8.25-11.5v15.375c6.375 10.5 17.268 10.27 24.5 5 8.063-5.875 6.5-14.25 5-43.625s-9.375-54.375-16.25-63.25c-8.225-10.618-22.25-18.75-37.875-20.5",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.385 759.063l5.646-3.832v-53.25c0-16.75-6.062-47.125-19.187-64.562-13.125-17.438-31-28.438-31-28.438h8.25c30.437 21.5 44.875 48.5 44.875 94.625v53.813s-3.18.708-8.584 1.644",
    fill: "#f8931f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.281 656.481c8.731-16.677 31.75-18 31.75-18l-5 12.5c20.25 4 36.25 27 37.25 60s-6 30.5-1.5 38 22.25 5.25 28 3.25c-2.682 3.471-7.353 6.74-11.44 9.184-9.844 1.194-21.81 2.191-34.34 2.191-31.22 0-58.97-6.187-58.97-6.187v-53.813c0-46.125 14.437-73.125 44.875-94.625h8.25c-30.375 21.625-38.875 47.5-38.875 47.5",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.906 608.981h8.25c-30.375 21.625-38.875 47.5-38.875 47.5 2.975-5.683 7.61-9.58 12.427-12.252-21.52 33.896-15.727 71.657-9.927 80.674-4.27-13.629 3.125-38.609 3.125-38.609.125 22.187 4.875 27.437 3.875 41.437-.846 11.833-2.754 22.062-2.572 33.247-12.763-1.686-21.178-3.56-21.178-3.56v-53.812c0-46.125 14.438-73.125 44.875-94.625",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.781 752.231c-2.682 3.471-7.353 6.74-11.44 9.184-9.844 1.194-21.81 2.191-34.34 2.191-3.457 0-6.866-.079-10.204-.214-4.106-2.542-6.102-7.16 2.847-19.16 12.864-17.25 11.387-39.5-6.113-55.46-17.5-15.962-26.75-32.54-18.823-44.543 9.32-5.17 19.323-5.748 19.323-5.748l-5 12.5c20.25 4 36.25 27 37.25 60s-6 30.5-1.5 38 22.25 5.25 28 3.25",
    fill: "#f8931f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.025 715.539a6.648 6.648 0 01-5.16 2.442h-8.799l2.834 14.513a8.089 8.089 0 01-1.702 6.717 8.09 8.09 0 01-6.267 2.958h-20.588a5 5 0 01-4.91-4.061l-8.813-46.1a4.996 4.996 0 014.911-5.938h10.416l-3.032-15.614a6.65 6.65 0 011.404-5.516 6.647 6.647 0 015.147-2.427h12.627l.182-.408a4.999 4.999 0 014.568-2.967h6.282a4.997 4.997 0 014.507 7.161l-.68 1.423 8.456 42.277a6.655 6.655 0 01-1.383 5.54",
    fill: "#f4eb3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.643 730.633l-2.354-12.902h-9.644l2.762 14.344h8.034c.763 0 1.34-.692 1.202-1.442m-5.835-31.96a1.22 1.22 0 00-1.202-1.004h-8.824l2.744 14.25h9.7zm11.124 39.496h-20.588l-8.812-46.099h19.864a5.247 5.247 0 015.15 4.242l2.954 15.124-4.437 2.545h2.036a3.518 3.518 0 013.453 2.844l3.442 17.627a3.12 3.12 0 01-3.062 3.717",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.081 669.858l8.425 42.122a1.674 1.674 0 01-1.64 2.002h-17.767s-.068 1.312-2.13 1.418c-2.063.107-.75-2.356-.75-2.356l2.718-4.875h11.625l-6.366-30.811h-4.79l1.433-3.22h-6.612l2.085 13.687h-7.125l-3.363-17.32a1.674 1.674 0 011.643-1.992h15.875l1.502-3.375h6.281l-1.763 3.675c.358.24.63.599.72 1.045",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.644 716.731l2.762 14.344h8.034c.763 0 1.34-.692 1.202-1.442l-2.354-12.902zm6.163-19.06a1.22 1.22 0 00-1.202-1.002h-8.824l2.744 14.25h9.702zm18.274-28.814l8.424 42.123a1.673 1.673 0 01-1.64 2.001h-17.767a3.517 3.517 0 013.453 2.844l3.442 17.627a3.12 3.12 0 01-3.062 3.716h-20.588l-8.812-46.099h19.864a5.248 5.248 0 015.151 4.243l2.315 11.856h9.701l-6.366-30.81h-4.79l1.432-3.22h-6.612l2.086 13.687h-7.125l-3.363-17.32a1.674 1.674 0 011.642-1.993h15.875l1.502-3.375h6.281l-1.762 3.676c.357.24.63.598.72 1.044",
    fill: "#260007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.094 767.555v-1.824c-3.25.75-10.563 1.625-10.563 1.625v2.406c-7.635 1.17-17.868 2-31.531 2-46.125 0-53.156-9.469-53.156-9.469s29.53 5.344 53.156 5.344c23.625 0 53.157-5.344 53.157-5.344s-2.034 2.733-11.063 5.262",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.469 778.231v-4.312s-5.937 1.312-10.813 2c0 0 .08 2.814 0 4.562-.125 2.75-16.374 7.063-16.374 7.063 11.999.312 22.25-1.876 24.749-3.876 2.5-1.999 2.438-2.812 2.438-5.437m-15.125 13.662v-2.849c-5.625 1.312-11.187 1.437-11.187 1.437v2.891c-4.76.435-10.134.703-16.157.703-32.062 0-45.781-7.594-45.781-7.594v-15.469s19.344 4.781 45.78 4.781c26.439 0 45.783-4.78 45.783-4.78v15.468s-5.738 3.168-18.438 5.412",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.844 762.294s6.412 1.16 15.647 2.399a25.96 25.96 0 00.989 4.189c-13.807-2.786-16.636-6.588-16.636-6.588M516.156 793.372c-4.759.435-10.134.703-16.156.703-32.063 0-45.782-7.594-45.782-7.594v-15.468s4.21 1.039 11.376 2.149c.018 6.697.232 10.374 2.75 12.569 2.627 2.292 11.665 5.388 47.812 5.525zM527.344 791.438c.66.033 1.27.07 1.839.111-.6.116-1.204.232-1.84.344z",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.313 800.263s-7.97 5.625-18.844 6.375c15.188 2.813 27.75-1.125 32.625-7.594 0 0-5.532.938-13.782 1.219M500 813.2c-15.093 0-26.578-8.063-29.812-17.813 0 0 18 2.344 29.812 2.344 11.813 0 29.813-2.344 29.813-2.344-3.234 9.75-14.719 17.813-29.813 17.813",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.188 795.388s3.037.396 7.432.86c6.129 9.993 15.63 14.695 25.134 16.86-.903.06-1.821.092-2.754.092-15.093 0-26.578-8.062-29.812-17.812",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.238 564.981h19.168l2.162 8.533c.125.495.57.842 1.081.842h109.882s1.5 6.75-11.5 6.75H442.656c-8 0-9.418-2.25-9.418-16.125",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.238 564.981h11.444l2.717 16.125h-4.743c-8 0-9.418-2.25-9.418-16.125",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.281 586.356h11.875l4.36 12.137c.16.442.58.738 1.05.738h84.215s0 5.25-8.25 5.25h-83.5c-6.125 0-8.25-2.5-8.75-6.625s-1-11.5-1-11.5",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.911 604.481h-1.88c-6.125 0-8.25-2.5-8.75-6.625s-1-11.5-1-11.5h7.122z",
    fill: "#fffffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.719 419.919v7.687l-76.5-3.843zM698.271 419.919v7.687l76.5-3.843z",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.968 744.576l-25.873 17.753a6.795 6.795 0 01-9.422-1.724l-10.517-15.124 4.125-2s-24-42.75-34.875-58.625c-5.872-8.572-12.388-15.57-17.146-20.202-2.042-7.747-4.898-15.858-8.842-22.173a72.1 72.1 0 00-8.218-10.765l27.956-18.985 3.625 5.375-2.875 2.375c19.75 28.375 74.875 110.25 74.875 110.25l3.625-1.625 5.03 6.886a6.07 6.07 0 01-1.468 8.584",
    fill: "#818286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.906 658.481l-3.75-5.125 19.417-5.68c1.155 1.696 2.332 3.423 3.52 5.17zM636.156 688.231l-3.75-5.125 19.38-5.669 3.504 5.175zM606.031 643.606l-3.75-5.125 19.174-5.609 3.54 5.166zM645.224 667.757l-19.067 5.6-3.75-5.126 19.305-5.648 3.512 5.174M652.906 712.356l18.777-5.494 3.496 5.18-18.523 5.44zM646.406 702.481l-3.75-5.125 18.873-5.52c1.188 1.753 2.356 3.483 3.501 5.176zM584.2 631.717c-10.586-11.457-21.336-15.61-21.336-15.61s2.406-3.76 4.062-12.07a9.855 9.855 0 006.83 2.744c5.465 0 9.898-4.432 9.898-9.9a9.87 9.87 0 00-3.36-7.42c1.391-2.92 2.57-6.73 3.302-11.704 11.968 17.536 20.828 30.569 25.276 37.205z",
    fill: "#fffeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.12 631.092l-.92.624c-10.586-11.457-21.336-15.61-21.336-15.61s1.871-2.93 3.45-9.323zM608.872 614.962l-5.408 3.673-22.06-31.843c.904-2.478 1.664-5.451 2.193-9.035 11.967 17.536 20.827 30.569 25.275 37.205",
    fill: "#00bdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.032 744.576l25.873 17.753a6.795 6.795 0 009.422-1.724l10.517-15.124-4.125-2s24-42.75 34.875-58.625c5.872-8.572 12.388-15.57 17.146-20.202 2.042-7.747 4.898-15.858 8.842-22.173a72.1 72.1 0 018.218-10.765l-27.956-18.985-3.625 5.375 2.875 2.375c-19.75 28.375-74.875 110.25-74.875 110.25l-3.625-1.625-5.03 6.886a6.07 6.07 0 001.468 8.584",
    fill: "#818286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.094 658.481l3.75-5.125-19.417-5.68c-1.155 1.696-2.332 3.423-3.52 5.17zM363.844 688.231l3.75-5.125-19.38-5.669a8851.467 8851.467 0 00-3.504 5.175zM393.969 643.606l3.75-5.125-19.174-5.609-3.54 5.166zM354.776 667.757l19.067 5.6 3.75-5.126-19.305-5.648-3.512 5.174M347.094 712.356l-18.777-5.494-3.496 5.18 18.523 5.44zM353.594 702.481l3.75-5.125-18.873-5.52c-1.188 1.753-2.356 3.483-3.501 5.176zM415.8 631.717c10.586-11.457 21.336-15.61 21.336-15.61s-2.406-3.76-4.062-12.07a9.855 9.855 0 01-6.83 2.744c-5.465 0-9.898-4.432-9.898-9.9a9.87 9.87 0 013.36-7.42c-1.391-2.92-2.57-6.73-3.302-11.704-11.968 17.536-20.828 30.569-25.276 37.205z",
    fill: "#fffeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.88 631.092l.92.624c10.586-11.457 21.336-15.61 21.336-15.61s-1.871-2.93-3.45-9.322zM391.128 614.962l5.408 3.673 22.06-31.843c-.904-2.478-1.664-5.451-2.193-9.035-11.967 17.536-20.827 30.569-25.275 37.205",
    fill: "#00bdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.582 641.585l-88.424-52.2a10.85 10.85 0 01-5.314-9.3v-15.104h4v15.105a6.831 6.831 0 003.347 5.855l88.653 52.334-2.262 3.31M715.84 589.386l-88.422 52.2c-.765-1.122-1.521-2.228-2.262-3.31l88.652-52.333a6.835 6.835 0 003.348-5.857v-15.104h4v15.104c0 3.8-2.036 7.364-5.315 9.3",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.547 300.231l-31.445-18-31.446 18v36.5l31.446 18 31.445-18zM530.856 300.231l-31.445-18-31.446 18v36.5l31.446 18 31.445-18zM441.702 300.231l-31.445-18-31.446 18v36.5l31.446 18 31.445-18zM620.57 300.231l-31.446-18-31.446 18v36.5l31.446 18 31.445-18zM710.281 300.231l-31.445-18-31.446 18v36.5l31.446 18 31.445-18z",
    fill: "none",
    stroke: "#ffffa9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.675 284.148l-121.233-71.205a2.842 2.842 0 00-2.884 0l-121.21 71.191-7.031-9.787 122.164-71.752a14.839 14.839 0 017.519-2.043c2.6 0 5.2.682 7.519 2.043l122.1 71.715z",
    fill: "#ff6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.99 280.869l-121.522-71.375a6.855 6.855 0 00-6.936 0l-121.528 71.378-2.344-3.262 121.847-71.565a10.835 10.835 0 015.493-1.492c1.9 0 3.8.497 5.493 1.492l121.811 71.545z",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.97 294.315l-35.851-51.893a5.358 5.358 0 00-8.848 6.045l38.287 56.666-9.011 8.578v-13.48a6 6 0 00-3.02-5.207l-16.78-9.605-62.715-91.938h13.744a57.482 57.482 0 0147.387 24.935c11.628 16.924 28.436 41.393 48.094 70.02z",
    fill: "#00bdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.812 292.836l-36.225-52.118a8.361 8.361 0 00-6.88-3.61 8.314 8.314 0 00-4.701 1.452c-3.797 2.585-4.793 7.783-2.221 11.588l38.623 57.032-2.359 2.245-4.502-6.605v-2.588a6.001 6.001 0 00-3.02-5.208l-3.764-2.155-62.731-92.012s23.06-5.725 45.25 25.125c11.12 15.46 28.028 40.435 45.176 65.475z",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.781 206.075l19.031 27.187 13.782-9.375c-7.782-9.468-19.782-19.875-32.813-17.812",
    fill: "#1c74b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.031 334.137l-4.354-6.36 4.354-3.709zM661.293 285.36l-16.884 9.664a5.999 5.999 0 00-3.018 5.207v13.42l-8.949-8.518 38.288-56.666a5.359 5.359 0 00-8.849-6.045l-35.851 51.893-11.287-5.879c19.658-28.627 36.466-53.096 48.094-70.02a57.484 57.484 0 0147.388-24.935h13.744z",
    fill: "#00bdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.41 295.024a6 6 0 00-3.02 5.207v2.681l-4.44 6.512-2.358-2.245 38.623-57.032c2.572-3.805 1.575-9.003-2.222-11.588a8.319 8.319 0 00-4.699-1.45 8.365 8.365 0 00-6.882 3.608l-36.224 52.12-2.646-1.38c17.148-25.04 34.056-50.015 45.177-65.476 22.19-30.85 45.25-25.125 45.25-25.125l-62.692 91.954z",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.219 206.075l-19.031 27.187-13.782-9.375c7.782-9.468 19.782-19.875 32.813-17.812",
    fill: "#1c74b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.969 334.137l4.354-6.36-4.354-3.709z",
    fill: "#00bdff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.968 232.794l-82.843 44.438 12.844 6.916 69.999-33.354 71.657 34.03 5.625-3.092L500 242.35z",
    fill: "#f7ec32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 242.35l-76.709 38.201 6.678 3.597 69.999-33.355z",
    fill: "#fffaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.031 315.762v-4.125l-9.28 10.031zM627.969 311.731l8.313 8.75-8.313-4.875z",
    fill: "#f7ec32"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M259.618 546.481l-6.651-88.625h83.565c30.783 0 32.08 9.527 32.975 21.652 1.337 18.098-21.351 24.598-21.351 24.598s19.375.376 19.75 22.625c.279 16.517-10.908 19.75-29.75 19.75zm19.494-14.656h55.636c3.224 0 6.335-1.351 8.536-3.705a11.721 11.721 0 003.125-8.765c-.409-6.115-5.532-10.905-11.661-10.905h-57.063zm-2.039-35.063h58.753c3.211 0 6.311-1.345 8.504-3.691a11.683 11.683 0 003.11-8.733c-.411-6.088-5.512-10.857-11.614-10.857h-60.324z",
    fill: "url(#i)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M397.66 546.481l-2.753-88.625h99.125v15.625h-77.438v23.281h71.437v11.688h-71.437v23.375h75.75v14.656z",
    fill: "url(#j)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M560.074 546.731L513.4 457.856h23.888l8.373 17.062h64.416l9.438-17.062h23.496l-50.801 88.875zm15.87-10.102l26.943-48.71h-50.846z",
    fill: "url(#k)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)",
    transform: "matrix(.35278 0 0 -.35278 -73.499 291.608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.776 382.47v8.805h37.575v11.344h-37.575v8.861h40.061v13.054h-56.625l-.615-55.678h58.211v13.613zM345.613 383.231a5.4 5.4 0 00-5.403 5.508c.1 4.975.3 11.996.441 16.757a5.396 5.396 0 005.401 5.235h28.7a5.404 5.404 0 005.402-5.527l-.383-16.693a5.404 5.404 0 00-5.402-5.28zm57.043-21.125l-11.015 12.78a16.39 16.39 0 014.04 10.222l.84 23.71c.31 8.695-6.657 15.913-15.359 15.913h-38.048c-9.915 0-18.049-7.85-18.4-17.759l-.775-21.827c-.308-8.696 6.657-15.914 15.36-15.914h39.611l6.496-7.125zM404.688 424.731h15.75v-34.344a7.156 7.156 0 017.156-7.156h19.625a7.156 7.156 0 017.157 7.156v34.344h16.125l-.478-38.836c-.116-9.444-7.806-17.039-17.25-17.039H421.51c-9.603 0-17.358 7.842-17.25 17.444zM546.063 387.512h16.312s-1.124-6.562 7.313-6.562h22.5c2.53 0 3.656 1.875 3.656 4.875s-.75 5.25-6.657 5.25h-23.906c-7.405 0-19.218 1.874-19.218 15.093 0 13.22 2.25 18.938 21.469 18.938H595c8.53 0 14.25-3.375 14.25-17.907h-15.657s-.187 5.907-6 5.907h-18.656c-3.75 0-7.406-.563-7.406-4.219 0-3.656 2.062-5.156 8.718-5.156h25.032c7.125 0 17.344-3.188 17.344-16.688 0-13.5-4.782-18.187-19.5-18.187h-33.282c-6.47 0-13.781 3.468-13.781 18.656M676.156 424.535h-60.563V411.23h23.032l2.168-41.832h15.32l-2.327 41.832h22.37z",
    fill: "#e4219a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.776 389.47v8.805h37.575v11.344h-37.575v8.861h40.061v13.054h-56.625l-.615-55.678h58.211v13.613zM344.613 390.231a5.4 5.4 0 00-5.403 5.508c.1 4.975.3 11.996.441 16.757a5.396 5.396 0 005.401 5.235h28.7a5.404 5.404 0 005.402-5.527l-.383-16.693a5.404 5.404 0 00-5.402-5.28zm57.043-21.125l-11.015 12.78a16.39 16.39 0 014.04 10.222l.84 23.71c.31 8.695-6.657 15.913-15.359 15.913h-38.048c-9.915 0-18.049-7.85-18.4-17.759l-.775-21.827c-.308-8.696 6.657-15.914 15.36-15.914h39.611l6.496-7.125zM405.531 431.075h15.75v-34.344a7.156 7.156 0 017.156-7.156h19.625a7.157 7.157 0 017.157 7.156v34.344h16.125l-.478-38.836c-.116-9.444-7.806-17.039-17.25-17.039H422.35c-9.602 0-17.357 7.842-17.25 17.444zM546.063 394.512h16.312s-1.124-6.562 7.313-6.562h22.5c2.53 0 3.656 1.875 3.656 4.875s-.75 5.25-6.657 5.25h-23.906c-7.405 0-19.218 1.874-19.218 15.093 0 13.22 2.25 18.938 21.469 18.938H595c8.53 0 14.25-3.375 14.25-17.907h-15.657s-.187 5.907-6 5.907h-18.656c-3.75 0-7.406-.563-7.406-4.219 0-3.656 2.062-5.156 8.718-5.156h25.032c7.125 0 17.344-3.188 17.344-16.688 0-13.5-4.782-18.187-19.5-18.187h-33.282c-6.47 0-13.781 3.468-13.781 18.656M676.156 431.535h-60.563V418.23h23.032l2.168-41.832h15.32l-2.327 41.832h22.37z",
    fill: "#16d1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.722 386.47v8.805h37.574v11.344h-37.574v8.861h40.06v13.054h-56.625l-.615-55.678h58.212v13.613zM342.613 387.231a5.4 5.4 0 00-5.403 5.508c.1 4.975.3 11.996.441 16.757a5.396 5.396 0 005.401 5.235h28.7a5.404 5.404 0 005.402-5.527l-.383-16.693a5.404 5.404 0 00-5.402-5.28zm57.043-21.125l-11.015 12.78a16.39 16.39 0 014.04 10.222l.84 23.71c.31 8.695-6.657 15.913-15.359 15.913h-38.048c-9.915 0-18.049-7.85-18.4-17.759l-.775-21.827c-.308-8.696 6.657-15.914 15.36-15.914h39.611l6.496-7.125zM403.531 428.731h15.75v-34.344a7.156 7.156 0 017.156-7.156h19.625a7.157 7.157 0 017.157 7.156v34.344h16.125l-.478-38.836c-.116-9.444-7.806-17.039-17.25-17.039H420.35c-9.602 0-17.357 7.842-17.25 17.444zM547.063 391.512h16.312s-1.124-6.562 7.313-6.562h22.5c2.53 0 3.656 1.875 3.656 4.875s-.75 5.25-6.657 5.25h-23.906c-7.405 0-19.218 1.874-19.218 15.093 0 13.22 2.25 18.938 21.469 18.938H596c8.53 0 14.25-3.375 14.25-17.907h-15.657s-.187 5.907-6 5.907h-18.656c-3.75 0-7.406-.563-7.406-4.219 0-3.656 2.062-5.156 8.718-5.156h25.032c7.125 0 17.344-3.188 17.344-16.688 0-13.5-4.782-18.187-19.5-18.187h-33.282c-6.47 0-13.781 3.468-13.781 18.656M679.156 428.535h-60.563V415.23h23.032l2.168-41.832h15.32l-2.327 41.832h22.37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.738 299.919h-29.273a4.301 4.301 0 00-4.3 4.3v28.524a4.301 4.301 0 004.3 4.3h29.273a4.301 4.301 0 004.301-4.3V304.22a4.301 4.301 0 00-4.3-4.301",
    fill: "#e47d22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 313.9h.01zm-16.402.58l7.702-4.409 7.7 4.41v8.94l-7.7 4.408-7.702-4.409zm7.702-6.56a1.01 1.01 0 00-.497.13l-8.701 4.982c-.312.18-.504.51-.504.868V324c0 .358.192.69.504.868l8.7 4.981a1 1 0 00.994 0l8.702-4.98a1 1 0 00.503-.869v-10.1a1 1 0 00-.503-.868l-8.702-4.982a1.005 1.005 0 00-.496-.13",
    fill: "#c35200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.197 324.226l-2.268 1.298-5.702-3.264v-6.62l4.073-2.33z",
    fill: "#fcffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.616 311.395l-5.389 3.085v8.94l7.702 4.41 2.952-1.69.683 1.913-3.138 1.796a1.002 1.002 0 01-.994 0l-8.7-4.98a1.004 1.004 0 01-.505-.87V313.9a1 1 0 01.504-.868l6.201-3.55z",
    fill: "#fcffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.164 305.919h2.18v25.375h31.695v2.44c0 .724-.586 1.31-1.309 1.31h-31.257a1.309 1.309 0 01-1.309-1.31z",
    fill: "#fcffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.719 319.731l-.088-.056V313.9a3.01 3.01 0 00-1.508-2.603l-8.703-4.982a3.002 3.002 0 00-2.98 0l-4.204 2.407-11.072-4.275v-2.528h33.875v22.367z",
    fill: "#c35200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.757 318.481c0-12.427-10.074-22.5-22.5-22.5-12.427 0-22.5 10.073-22.5 22.5s10.073 22.5 22.5 22.5c12.426 0 22.5-10.073 22.5-22.5",
    fill: "#cfd2d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.652 313.431h.01zm-16.403.58l7.701-4.409 7.702 4.41v8.94l-7.702 4.408-7.7-4.409zm7.701-6.56c-.17 0-.343.043-.496.13l-8.702 4.982a1 1 0 00-.503.868v10.1a1 1 0 00.503.868l8.702 4.981a1 1 0 00.993 0l8.701-4.98c.312-.18.504-.51.504-.869v-10.1c0-.358-.192-.689-.504-.868l-8.7-4.982a1.01 1.01 0 00-.498-.13",
    fill: "#6c6d71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.219 323.758l-2.27 1.298-5.7-3.264v-6.621l4.072-2.33z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.637 310.926l-5.388 3.085v8.94l7.7 4.41 2.953-1.69.683 1.914-3.137 1.796a1.002 1.002 0 01-.994 0l-8.702-4.981a1.003 1.003 0 01-.503-.87v-10.099a1 1 0 01.503-.868l6.202-3.55z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.257 338.981c-11.304 0-20.5-9.196-20.5-20.5 0-2.57.496-5.022 1.363-7.29l3.503-.529a17.373 17.373 0 00-1.866 7.82c0 9.648 7.85 17.5 17.5 17.5 5.566 0 10.523-2.623 13.73-6.687l.634 3.788c-3.702 3.642-8.772 5.898-14.364 5.898",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.74 331.876c-.228-1.766-.598-4.344-1.015-6.051-.687-2.812-2.687-6.062-2.687-6.062l-.386-.234v-6.097c0-1.073-.578-2.07-1.509-2.603l-8.703-4.982a3.002 3.002 0 00-2.978-.001l-5.768 3.3-11.13.96c3.211-7.135 10.373-12.125 18.693-12.125 11.303 0 20.5 9.197 20.5 20.5 0 5.122-1.9 9.798-5.017 13.395",
    fill: "#6c6d71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.418 294.966l-20.522 20.522a4.232 4.232 0 000 5.987l20.522 20.522a4.232 4.232 0 005.987 0l20.522-20.522a4.234 4.234 0 000-5.987l-20.522-20.522a4.234 4.234 0 00-5.987 0",
    fill: "#f0f328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.728 313.869h.01zm-16.403.58l7.702-4.41 7.701 4.41v8.94l-7.7 4.409-7.703-4.41zm7.702-6.561a1.01 1.01 0 00-.497.13l-8.7 4.983c-.313.179-.505.51-.505.868v10.1c0 .358.192.689.504.868l8.701 4.98a1 1 0 00.993 0l8.702-4.98a1 1 0 00.503-.868v-10.1a1 1 0 00-.503-.868l-8.702-4.982a1.005 1.005 0 00-.496-.131",
    fill: "#f5941d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.295 324.195l-2.268 1.298-5.702-3.264v-6.62l4.073-2.33z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.714 311.364l-5.39 3.085v8.939l7.703 4.41 2.952-1.69.683 1.914-3.138 1.796a1.002 1.002 0 01-.994 0l-8.701-4.981a1.004 1.004 0 01-.504-.869v-10.099a1 1 0 01.504-.868l6.2-3.55z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.34 338.044l17.53-17.156 1.807 1.009-18.687 18.686a2.215 2.215 0 01-1.58.654 2.219 2.219 0 01-1.578-.654l-20.937-20.937a1.647 1.647 0 010-2.33l1.665-1.664z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.513 320.06l-.981.982-9.803-4.936v-2.237c0-1.073-.578-2.07-1.508-2.603l-8.703-4.982a3.002 3.002 0 00-2.98 0l-8.703 4.981c-.104.061-.187.146-.284.218h-5.822l15.103-15.104a2.219 2.219 0 011.579-.654 2.22 2.22 0 011.58.654l20.522 20.523c.87.871.87 2.287 0 3.158",
    fill: "#f5941d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.526 293.95c-14.735 8.866-20.437 16.261-20.559 36.838-.002.415.223.806.584 1.009l20.015 11.233c.347.194.77.194 1.114 0l20.015-11.233c.361-.203.586-.594.584-1.009-.122-20.577-5.823-27.972-20.559-36.838a1.172 1.172 0 00-1.194 0",
    fill: "#85e3ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.209 314.12h.009zm-15.241.539l7.156-4.097 7.155 4.097v8.307l-7.155 4.096-7.156-4.096zm7.156-6.097a.93.93 0 00-.462.123l-8.085 4.628a.932.932 0 00-.468.807v9.385c0 .333.179.64.468.806l8.085 4.628a.932.932 0 00.923 0l8.085-4.628a.928.928 0 00.468-.806v-9.385a.93.93 0 00-.468-.807l-8.085-4.628a.926.926 0 00-.461-.123",
    fill: "#6fbcae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.23 323.715l-2.106 1.206-5.298-3.032v-6.153l3.783-2.165z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.975 311.793l-5.007 2.866v8.307l7.156 4.097 2.742-1.571.635 1.779-2.916 1.668a.927.927 0 01-.923 0l-8.084-4.627a.93.93 0 01-.468-.807v-9.385c0-.333.178-.64.468-.806l5.76-3.3z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.138 320.083v-5.963a2.936 2.936 0 00-1.472-2.541l-8.088-4.63a2.94 2.94 0 00-2.902-.005l-8.093 4.634a2.938 2.938 0 00-1.473 2.542v1.223h-6.298c2.622-8.931 8.152-13.858 17.312-19.416 12.323 7.478 18.075 13.817 19.015 30.3z",
    fill: "#6fbcae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.781 316.217v9.844l17.062 9.375 14.438-8.374h2.901c.05 1.041.081 2.116.093 3.238l-19.15 10.75-19.154-10.75c.061-5.653.58-10.23 1.6-14.083z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.47 294.74l-21.46 15.524a2.33 2.33 0 00-.828 2.668l8.692 24.428a2.329 2.329 0 002.195 1.549h25.535c.985 0 1.864-.62 2.194-1.549l8.693-24.428a2.332 2.332 0 00-.83-2.668L680.2 294.74a2.327 2.327 0 00-2.73 0",
    fill: "#44c4fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.344 314.725h.009zm-16.038.567l7.53-4.31 7.529 4.31v8.74l-7.53 4.311-7.53-4.31zm7.53-6.415a.973.973 0 00-.485.13l-8.508 4.87a.977.977 0 00-.492.848v9.874c0 .351.187.674.492.85l8.508 4.87c.3.171.67.171.97 0l8.508-4.87a.978.978 0 00.493-.85v-9.874a.978.978 0 00-.493-.849l-8.507-4.87a.98.98 0 00-.486-.129",
    fill: "#008fb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.053 324.821l-2.217 1.269-5.574-3.191v-6.474l3.98-2.278z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.574 312.276l-5.269 3.017v8.74l7.531 4.31 2.884-1.652.67 1.871-3.069 1.756a.978.978 0 01-.97 0l-8.508-4.87a.978.978 0 01-.493-.849v-9.874c0-.35.188-.674.493-.848l6.063-3.472z",
    fill: "#fdfeff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.606 312.262l-3.2 8.995-7.085-5.444v-1.087a2.983 2.983 0 00-1.497-2.583l-8.51-4.871a2.977 2.977 0 00-2.956-.002l-3.583 2.051h-13.048l17.914-12.96a.331.331 0 01.387 0l21.46 15.524c.118.085.166.24.118.377",
    fill: "#008fb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.281 334.971h24.243l-.61 1.72a.328.328 0 01-.31.217h-25.536a.328.328 0 01-.31-.219l-8.693-24.427a.332.332 0 01.118-.378l2.32-1.678z",
    fill: "#fdfeff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeatquestSeal);
export default __webpack_public_path__ + "static/media/beatquest-seal.d5a5fc199c2a49f17da8181287dc398b.svg";
export { ForwardRef as ReactComponent };